<template>
  <div :class="[{}]" class="ps-form-fieldps-relative">
    <base-label v-if="!hideLabel">{{ label }}</base-label>
    <slot :applyFocus="applyFocus" :removeFocus="removeFocus" />
    <div class="ps-mt-1 ps-relative">
      <component
        :is="inputName"
        :vuelidate="vuelidate"
        v-model="vuelidate.$model"
        @input-focus="applyFocus"
        @input-blur="removeFocus"
        :placeholder="placeholder"
        :options="options"
        :user-avatar="userAvatar"
      />
    </div>
  </div>
</template>

<script>
import BaseInput from '@/components/inputs/BaseInput'
import BaseSelect from '@/components/inputs/BaseSelect'
import BaseTextarea from '@/components/inputs/BaseTextarea'
import InputUnderline from '@/components/inputs/InputUnderline'
import BaseLabel from '@/components/forms/BaseLabel'
import TailwindSelect from '@/components/inputs/TailwindSelect'

export default {
  name: 'BaseFormField',
  props: {
    label: String,
    inputName: String,
    vuelidate: Object,
    hideLabel: Boolean,
    placeholder: String,
    options: Array,
    userAvatar: Boolean
  },
  components: {
    BaseInput,
    BaseTextarea,
    BaseSelect,
    BaseLabel,
    InputUnderline,
    TailwindSelect
  },
  data() {
    return {
      isFocused: false
    }
  },
  methods: {
    applyFocus() {
      this.isFocused = true
    },
    removeFocus() {
      this.isFocused = false
    }
  }
}
</script>
